/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Button, Col, Row, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { ChatGPTSearcher } from '@/components/forms/chatGPT-management-search.form';
import { ChatGPTManagementTable } from '@/components/tables/chatGPT-management.table';
import { useCallback, useState } from 'react';
import { PAGINATION_PARAMS } from '@/constants/pagination.constant';
import { useAppDispatch } from '@/redux/hooks';
import { getListBanner } from '@/redux/slices/banner.slice';
import { PageURLs } from '@/utils/navigate';
import { PermissionMode } from '@/enums/mode.enum';
import { useQuery } from '@/hooks/query.hook';
import SquareButton from '@/components/square-button';
import Download from '@/assets/svgs/download.svg?react';
import Synchronous from '@/assets/svgs/synchronous.svg?react';

type PageChangeParams = {
  page?: number;
  pageSize?: number;
  filter?: FilterBanner;
};

export default function ChatGPT() {
  const dispatch = useAppDispatch();
  const [filter, setFilter] = useState<FilterBanner>({});
  const { push } = useQuery();

  const handlePageChange = useCallback(
    ({
      page = PAGINATION_PARAMS.offset,
      pageSize = PAGINATION_PARAMS.limit,
      filter
    }: PageChangeParams) => {
      dispatch(
        getListBanner({
          offset: page,
          limit: pageSize,
          platform: filter?.platform,
          active: filter?.active,
          name: filter?.textSearch,
          sort_by: 'ASC'
        })
      );
    },
    [dispatch]
  );

  const handleSearch = (values: FilterBanner) => {
    const newFilter = {
      ...filter,
      ...values
    };
    setFilter(newFilter);
    handlePageChange({ filter: newFilter });
  };

  const handleAddBanner = () => {
    push(`${PageURLs.ofChatGPT()}?mode=${PermissionMode.CREATE}`);
  };
  return (
    <div css={rootStyles}>
      <Row css={boxStyles} justify='space-between' align='middle'>
        <Col>
          <Typography.Title css={titleStyles} level={5}>
            Quản lý nội dung ChatGPT
          </Typography.Title>
        </Col>
        <Col>
          <Row justify='space-between' css={{ gap: '10px' }}>
            <div  css={{ width: '20rem' }}>
              <SquareButton hasBorder={true} textColor='default' height={31.5} backgroundColor='white'>
                <Download width={20} height={20}/>
                Tải xuống
              </SquareButton>
            </div>
            <div  css={{ width: '20rem' }}>
              <SquareButton hasBorder={true} textColor='default' height={31.5} backgroundColor='white'>
                <Synchronous width={20} height={20}/>
                Đồng bộ lên Chat GPT
              </SquareButton>
            </div>
            <Button
              type='primary'
              icon={<PlusOutlined />}
              iconPosition='start'
              onClick={handleAddBanner}
              style={{ backgroundColor: '#52C41A', borderColor: '#52C41A' }}
            >
              Nhập Excel
            </Button>
            <Button
              type='primary'
              icon={<PlusOutlined />}
              iconPosition='start'
              onClick={handleAddBanner}
            >
              Thêm mới câu hỏi
            </Button>
          </Row>
        </Col>
      </Row>
      <div css={boxStyles}>
        <ChatGPTSearcher onSearch={handleSearch} />
      </div>
      <div css={tableStyles}>
        <ChatGPTManagementTable
          handleSearch={handleSearch}
          handlePageChange={handlePageChange}
          filter={filter}
        />
      </div>
    </div>
  );
}
const rootStyles = css`
  background: var(--gray-soft-color);
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
  padding: 1.4rem 2.4rem;
  min-height: calc(100vh - var(--header-height));
`;

const boxStyles = css`
  padding: 1rem;
  background: var(--white-color);
  border-radius: 1rem;
  box-shadow: 0.02rem 0.04rem 0.2rem var(--gray-light-color);
  &:nth-of-type(2) {
    padding: 1.6rem 1rem;
  }
`;

const titleStyles = css`
  margin-bottom: 0 !important;
  line-height: 3.2rem !important;
`;

const tableStyles = css`
  background: var(--white-color);
  border-radius: 1rem;
  padding: 0 1rem;
  .table-top {
    padding: 1rem 0;
  }
`;
